"use client";

import Link from "@casino/client/components/Link";
import Img from "@casino/legacyUi/Img";
import type { GamePageTranslations } from "@casino/server/graphql/getCmsGamePagePhrases";
import type { HomeBoostGame } from "@casino/server/graphql/getHomeBoostGames";
import translatePhrase from "@casino/ui/Games/translatePhrase";
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@workspace/frontend-ui";
import type { FC } from "react";

type Props = {
  games: HomeBoostGame[];
  allowedGames?: string;
  translations?: GamePageTranslations;
};

const BoostAvailableGames: FC<Props> = ({
  games,
  allowedGames,
  translations,
}) => {
  if (!games.length) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          data-testid="boost-available-games"
          variant="secondary"
          className="relative z-10 w-fit max-sm:mt-1 h-10 text-primary!"
        >
          {translatePhrase(
            translations,
            "casino.boosts.show_available_games",
            "Show available games",
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-80 p-2">
        {games.map((game) => (
          <DropdownMenuItem key={game.id} asChild className="gap-3 p-2">
            <Link href={game.href ?? ""}>
              {game.thumbnail && (
                <Img
                  src={game.thumbnail}
                  alt=""
                  width={40}
                  height={40}
                  className="shrink-0 rounded-lg object-cover"
                />
              )}
              <span className="flex min-w-0 flex-col gap-0.5">
                <span className="truncate font-semibold">{game.name}</span>
                {game.provider && (
                  <span className="truncate text-xs text-muted-foreground uppercase">
                    {game.provider}
                  </span>
                )}
              </span>
            </Link>
          </DropdownMenuItem>
        ))}
        {allowedGames && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem asChild>
              <Link href={`/games/boosted-games/${allowedGames}`}>
                {translatePhrase(
                  translations,
                  "casino.see_all_games",
                  "See all games",
                )}
              </Link>
            </DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default BoostAvailableGames;
